import React from 'react';

const SearchIcon = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 4C5.96243 4 3.5 6.46243 3.5 9.5C3.5 12.5376 5.96243 15 9 15C10.519 15 11.893 14.3852 12.8891 13.3891C13.8852 12.393 14.5 11.019 14.5 9.5C14.5 6.46243 12.0376 4 9 4ZM2 9.5C2 5.63401 5.13401 2.5 9 2.5C12.866 2.5 16 5.63401 16 9.5C16 11.1625 15.4197 12.6906 14.4517 13.8911L17.7803 17.2197C18.0732 17.5126 18.0732 17.9874 17.7803 18.2803C17.4874 18.5732 17.0126 18.5732 16.7197 18.2803L13.3911 14.9517C12.1906 15.9197 10.6625 16.5 9 16.5C5.13401 16.5 2 13.366 2 9.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SearchIcon;
